import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const clientsSlice = createSlice({
  name: 'colaboradores',
  initialState: {
    user: {}
  },
  reducers: {
    setColabs: (state, { payload }) => {
      state.data = payload;
    }
  }
});

export const { setColabs } = clientsSlice.actions;

export const getClient = id => async () => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/clients/${id}`
    );

    return data;
  } catch (e) {
    console.log(e);
  }
};

export default clientsSlice.reducer;
